export { TalkGrid } from './TalkGrid';
export type { TalkGridProps } from './TalkGrid.props';
